import { apiSlice } from "../../app/api/apiSlice";


export const getLoanApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getLoan: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/user/get_loan_data/",
				method: "POST",
				body: {
					loanid: credentials?.loanid,
				},
				
			}),
		}),
	}),
});

export const { useGetLoanMutation } = getLoanApiSlice;
